import React, {useEffect} from 'react';
import {PeerProfile_Internal_Panel, RootInternalDialog} from "../../../index";

const PeerProfile_Internal_Dialog = React.memo(({
                                                    recordId,
                                                    open,
                                                    onHide,
                                                    asDrawer = false,
                                                }) => {
    const TAG = "PeerProfile_Internal_Dialog";

    useEffect(() => {

    }, []);

    return (<>
            <RootInternalDialog
                open={open}
                title={"Profile Details"}
                asDrawer={asDrawer}
                onHide={onHide}>
                <PeerProfile_Internal_Panel
                    recordId={recordId}
                    showTitle={true}
                    justifyAt={'center'}
                />
            </RootInternalDialog>
        </>
    )
});
export default PeerProfile_Internal_Dialog;
